import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";


export default function DrawerMaster({ toggleDrawer, open, children, widthList='130vh', top = "1%", styles='',  display="right" }) {
  const useStyles = makeStyles({
    list: {
      width: widthList,
    },
  });
  const classes = useStyles();

  return (
    <React.Fragment key={display}>
      <Drawer
        classes={styles}
        anchor={display}
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          style: {
            borderRadius: "8px",
            maxHeight: "100vh",
            top: top,
          },
        }}>
        <div className={clsx(classes.list)} role='presentation'>
          <div
            style={{
              padding: "1rem",
            }}>
            {children}
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
}
